import { CXF } from '@goodgamestudios/cxf-runtime'
import bfController from './bigfarm/bf-controller'
import emController from './empire/em-controller'
import log from '../utils/logger'
import { gameAlias, gameAliasToIdMap } from '../constants'

const GAMES_MAP = new Map([
  [gameAliasToIdMap.EMPIRE, emController],
  [gameAliasToIdMap.BIGFARM, bfController],
])

export const getGameController = (cxf: CXF) => {
  const gameId = Number.parseInt(cxf.gameId, 10) as gameAlias
  if (!GAMES_MAP.has(gameId)) {
    log(`Game controller is not registered for the game - [${gameId}]`)
    throw new Error(`Game controller is not registered for the game - [${gameId}]`)
  }

  return GAMES_MAP.get(gameId)!
}
